import { LayoutActionCollection, PageToolbarActions } from "../../../../page-actions"

import { DesignEvent } from "../../../../../base/models"
import { DesignerMode } from "../../../../types"
import { DndContextProvider } from "../../../../dnd/DndContextProvider"
import { FC } from "react"
import { IPage } from "../../../models"

interface IPageActionsViewSwitchProps {
    page: IPage,
    editMode: DesignerMode,
    onDesignChange: (event: DesignEvent) => void
}

export const PageActionsViewSwitch: FC<IPageActionsViewSwitchProps> = ({
    page, editMode: viewType, onDesignChange
}) => {
    const getComponent = () => {
        switch (viewType) {
            case DesignerMode.Draft:
                return <DndContextProvider>
                    <LayoutActionCollection
                        actions={page.actions || []}
                        onDesignChange={onDesignChange} />
                </DndContextProvider>
            case DesignerMode.View:
                return <div className="m-5">
                    <PageToolbarActions actions={page.actions || []} className="flex-column" />
                </div>
        }
    }

    return <div className="position-relative">
        {getComponent()}
    </div>
}